var _path, _circle, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEye = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 13,
  viewBox: "0 0 16 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0.912491 7.03615C0.722327 6.81595 0.573428 6.63151 0.470554 6.5C0.573428 6.3685 0.722327 6.18405 0.912491 5.96385C1.30865 5.50514 1.88155 4.894 2.58822 4.28384C4.0132 3.05346 5.92667 1.875 8 1.875C10.0733 1.875 11.9868 3.05346 13.4118 4.28384C14.1185 4.894 14.6914 5.50514 15.0875 5.96385C15.2777 6.18405 15.4266 6.3685 15.5294 6.5C15.4266 6.63151 15.2777 6.81595 15.0875 7.03615C14.6914 7.49486 14.1185 8.106 13.4118 8.71616C11.9868 9.94654 10.0733 11.125 8 11.125C5.92667 11.125 4.0132 9.94654 2.58822 8.71616C1.88155 8.106 1.30865 7.49486 0.912491 7.03615ZM15.6952 6.2815C15.6952 6.28151 15.6952 6.28148 15.6952 6.2815L15.6952 6.2815Z",
  stroke: "currentColor",
  strokeWidth: 0.75
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 6.5,
  r: 2.75,
  stroke: "currentColor",
  strokeWidth: 0.5
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 2.73483,
  y1: 12.2348,
  x2: 13.7348,
  y2: 1.23483,
  stroke: "currentColor",
  strokeWidth: 0.75
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgEye);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/eye.1890a6549d29e2a9e626d4d01dc35e32.svg";